function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 5,
  y: 5,
  width: 160,
  height: 100,
  rx: 5,
  fill: "#FFF36D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#202020",
  d: "M30.5 65 22.9 40h8.4l3.7 14.8L39.5 40h7.4l4.5 14.8L55.1 40h8.1L55.7 65h-8.1l-4.5-14.4L38.6 65h-8.1Zm45.4.6c-8.4 0-14-5.2-14-13.1 0-7.7 5.4-13.1 13.1-13.1 7.5 0 12.6 5.1 12.6 12.7 0 .9-.1 1.9-.2 2.6H70.1c.7 2.9 2.8 4.5 6.2 4.5 2.6 0 4.8-.8 6.8-2.4l3.5 5.1c-2.7 2.4-6.4 3.7-10.7 3.7Zm-5.7-15.8h9.6c-.5-2.6-2.2-4-4.7-4-2.6 0-4.3 1.4-4.9 4Zm21.2 15.2V40h7.6v3.3c1.8-2.4 4.3-3.7 7.5-3.7h1.4v7.6c-.8-.2-1.6-.3-2.6-.3-3.8 0-6 2.2-6 6.2V65h-7.9Zm31.4.6c-7.9 0-13.6-5.5-13.6-13.1 0-7.6 5.7-13.1 13.6-13.1 7.9 0 13.6 5.5 13.6 13.1 0 7.6-5.7 13.1-13.6 13.1Zm0-6.8c3.4 0 5.7-2.5 5.7-6.3 0-3.8-2.3-6.3-5.7-6.3s-5.7 2.5-5.7 6.3c0 3.8 2.3 6.3 5.7 6.3Z"
});

var SvgWero = function SvgWero(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 170 110",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWero, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Wero.0804eb64.svg";
export { ForwardRef as ReactComponent };